export const img = (id, w = 1600) =>
  `https://images.unsplash.com/${id}?q=80&w=${w}&auto=format&fit=crop`;

export const REGIONS = [
  "United States",
  "Canada",
  "United Arab Emirates",
  "Saudi Arabia",
  "Qatar",
  "Oman",
  "Bahrain",
  "Kuwait",
];

export const SOLUTIONS = [
  {
    name: "Direct Hire",
    tagline: "Permanent recruitment for critical professional and operational positions.",
    description:
      "Precision search for permanent hires who shape performance from day one. We map the market, approach passive talent and manage the process end to end — discreetly and at pace.",
    deliverables: [
      "Dedicated search lead and market mapping",
      "Structured competency assessment",
      "Shortlist within agreed timelines",
      "Offer management and onboarding support",
    ],
  },
  {
    name: "Executive Search",
    tagline: "Confidential search for senior leadership and strategic appointments.",
    description:
      "Board-level and C-suite mandates handled with absolute discretion. Our consultants combine North American search methodology with deep GCC networks to secure leaders who move organizations forward.",
    deliverables: [
      "Confidential mandate management",
      "Global talent mapping and benchmarking",
      "Leadership assessment and referencing",
      "Succession and pipeline advisory",
    ],
  },
  {
    name: "Recruitment Process Outsourcing",
    tagline: "Dedicated recruitment capacity designed around your hiring objectives.",
    description:
      "An embedded talent acquisition function that scales with demand. We design, run and optimize your recruitment engine — technology, process, employer brand and delivery — under one accountable partnership.",
    deliverables: [
      "Embedded or hybrid delivery teams",
      "Process design and ATS optimization",
      "Employer brand and candidate experience",
      "Hiring analytics and SLA reporting",
    ],
  },
  {
    name: "Talent Advisory",
    tagline: "Market intelligence, hiring strategy, compensation insights and workforce planning.",
    description:
      "Evidence before decisions. We provide GCC salary benchmarking, talent pool analysis, organization design and workforce planning so leadership teams hire with conviction.",
    deliverables: [
      "Compensation and benefits benchmarking",
      "Talent pool and competitor intelligence",
      "Workforce and succession planning",
      "Market entry hiring strategy",
    ],
  },
];

export const INDUSTRIES = [
  {
    name: "Banking & Financial Services",
    blurb: "Front office to treasury, risk and compliance for regional and international institutions.",
    image: "photo-1611974789855-9c2a0a7236a3",
  },
  {
    name: "Technology",
    blurb: "Engineering, data, product and digital leadership for platforms scaling across the region.",
    image: "photo-1518770660439-4636190af475",
  },
  {
    name: "Real Estate & Construction",
    blurb: "Development, commercial and project leadership for landmark GCC assets.",
    image: "photo-1504307651254-35680f356dfd",
  },
  {
    name: "Energy & Utilities",
    blurb: "Leadership and specialist talent across conventional and renewable energy programmes.",
    image: "photo-1466611653911-95081537e5b7",
  },
  {
    name: "Healthcare",
    blurb: "Clinical leadership and executive appointments for premium healthcare groups.",
    image: "photo-1576091160399-112ba8d25d1d",
  },
  {
    name: "Legal",
    blurb: "Counsel, partners and compliance leaders for firms and in-house teams.",
    image: "photo-1589829545856-d10d557cf95f",
  },
  {
    name: "Logistics & Supply Chain",
    blurb: "Operations, network and commercial talent for regional distribution leaders.",
    image: "photo-1578575437130-527eed3abbec",
  },
  {
    name: "Consulting & Professional Services",
    blurb: "Strategy, advisory and transformation talent for top-tier and boutique firms.",
    image: "photo-1454165804606-c3d57bc86b40",
  },
];

export const INSIGHTS = [
  {
    tag: "Market Report",
    title: "GCC Hiring Outlook: What Executive Talent Expects in 2026",
    excerpt:
      "Compensation is only part of the equation. Senior candidates across the Gulf are weighing mandate quality, governance and long-term career architecture more heavily than ever.",
    date: "June 2026",
    readTime: "8 min read",
    image: "photo-1486406146926-c627a92ad1ab",
  },
  {
    tag: "Salary Guide",
    title: "UAE & KSA Compensation Benchmarks: Leadership Edition",
    excerpt:
      "A concise read on executive pay movements across Dubai, Abu Dhabi and Riyadh — and where premiums are emerging for transformation leadership.",
    date: "May 2026",
    readTime: "12 min read",
    image: "photo-1526304640581-d334cdbbf45e",
  },
  {
    tag: "Talent Advisory",
    title: "Why RPO Is Replacing Reactive Hiring in the Gulf",
    excerpt:
      "Organizations building for Vision 2030-scale growth are moving from transactional recruitment to embedded talent acquisition partnerships.",
    date: "April 2026",
    readTime: "6 min read",
    image: "photo-1521737604893-d14cc237f11d",
  },
  {
    tag: "Executive Search",
    title: "The Discretion Premium: Running Confidential Searches in the GCC",
    excerpt:
      "How boards replace senior leaders without unsettling markets, teams or stakeholders — a practical framework for confidential mandates.",
    date: "March 2026",
    readTime: "7 min read",
    image: "photo-1431540015161-0bf868a2d407",
  },
  {
    tag: "Workforce Planning",
    title: "Building Nationalization-Ready Talent Pipelines",
    excerpt:
      "Emiratisation and Saudization done well are talent strategies, not quotas. A field guide to sustainable national workforce programmes.",
    date: "February 2026",
    readTime: "9 min read",
    image: "photo-1497366216548-37526070297c",
  },
  {
    tag: "Candidate Playbook",
    title: "Positioning Yourself for a GCC Leadership Move",
    excerpt:
      "What international executives should understand about mandate scope, stakeholder complexity and relocation strategy before entering the market.",
    date: "January 2026",
    readTime: "5 min read",
    image: "photo-1556761175-b413da4baf72",
  },
];

export const PROCESS_STEPS = [
  { name: "Discovery & Brief", text: "We immerse in your business, culture and mandate to define what exceptional looks like." },
  { name: "Market Mapping", text: "A complete view of the talent landscape across the GCC and international markets." },
  { name: "Search & Assessment", text: "Discreet approach, structured assessment and rigorous referencing of shortlisted talent." },
  { name: "Shortlist & Interviews", text: "A precise, qualified shortlist with full interview orchestration and feedback loops." },
  { name: "Offer & Onboarding", text: "Offer strategy, negotiation and post-placement follow-through that protects the hire." },
];
